export const socialsData = {
    github: 'https://github.com/sipundhal',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/smruti-ranjan-dhal-3189b2125/',
    instagram: 'https://instagram.com/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/DjsipunE?t=49BKKwljbanYqjT1vtWe9A&s=08/',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}